const PHRASE =
    "ADAM WAS HER CHILD \u00B7 WHAT HURTS? \u00B7 EVE CAME FIRST \u00B7 THE GARDEN IS WITHIN YOU \u00B7 SHE IS COMING BACK \u00B7 FIRSTCAMEEVE.COM \u00B7 ";

export default function EditorialMarquee() {
    return (
        <div
            className="marquee relative z-10 border-y border-[rgba(212,175,55,0.18)] py-5"
            data-testid="editorial-marquee"
            aria-hidden="true"
        >
            <div className="marquee-track">
                {[0, 1].map((n) => (
                    <span
                        key={n}
                        className="font-cinzel px-4 text-sm tracking-[0.35em] text-[rgba(212,175,55,0.45)] uppercase"
                    >
                        {PHRASE.repeat(3)}
                    </span>
                ))}
            </div>
        </div>
    );
}
